<template>
  <div
    class="comments"
    data-qa="comments">
    <div class="comments-col-1">
      <CommentCard
        v-for="(organizationsItem, organizationsItemIndex) in items"
        :key="`question-${organizationsItemIndex}-${organizationsItem.organizationId}`"
        class="comments-item"
        :class="{'active': activeItemId === organizationsItem.organizationId}"
        :data-qa="`question-${organizationsItemIndex}`"
        :item="organizationsItem"
        :show-button="false"
        @openChat="val => $emit('update:itemId', val)"/>
    </div>
    <div class="comments-col-2">
      <ChatTemplate
        v-if="activeChats && activeChats[0]"
        chat
        :disabled="!answerComment"
        :loading="loading"
        :text.sync="text"
        @send="send">
        <div
          :key="`org-info-${activeChats[0].organizationTitle}`"
          slot="title"
          class="flex width-100">
          <UserIcon
            :key="`user-icon-${activeChats[0].organizationTitle}`"
            :name="activeChats[0].organizationTitle"
            size="38"/>
          <div
            :key="`organizationTitle-${activeChats[0].organizationTitle}`"
            class="comments-head-title"
            data-qa="organizationTitle">
            {{ activeChats[0].organizationTitle }}
          </div>
        </div>
        <template v-slot:items>
          <CommentsChat
            :key="`comments-chat-${activeChats[0].organizationId}`"
            class="width-100"
            :items="activeChats"
            :show="show"
            @answer="value => answerComment = value"/>
        </template>
        <template
          v-slot:beforeInput>
          <transition
            name="s-zoom-in-bottom">
            <div
              v-if="answerComment"
              class="comments-question">
              <div style="overflow: hidden;">
                <div
                  class="comments-question-title">
                  {{ answerComment.value.organizationTitle }}
                </div>
                <div
                  class="comments-question-question">
                  {{ answerComment.value.question }}
                </div>
              </div>
              <sButton
                :disabled="loading"
                icon="cross"
                icon-size="10px"
                small
                type="text"
                @click="answerComment = null"/>
            </div>
          </transition>
        </template>
      </ChatTemplate>
    </div>
  </div>
</template>
<script>
import UserIcon from 'components/header/UserIcon.vue'
import CommentCard from 'components/common/blocks/comments/CommentCard.vue'
import ChatTemplate from 'components/common/blocks/history/ChatTemplate.vue'
import CommentsChat from 'components/common/blocks/comments/CommentsChat.vue'
import { mapGetters } from 'vuex'
import { debounce } from 'toolkit/utils/util'

import SmarttenderApi from '@/api/smarttenderApi'
const api = new SmarttenderApi()

export default {
  name: 'dialogComments',
  data() {
    return {
      loading: false,
      commentIndex: 0,
      answerComment: null,
      text: '',
    }
  },
  methods: {
    send: debounce(async function (answer) {
      if (!answer) { return }
      this.loading = true
      await api.answerToParticipant(  {
        questionId: this.answerComment.value.questionId,
        answer,
        fixAnswer: !!this.answerComment.value.answer
      }).then(res => {
        res = res.data.answerToParticipant
        if (res) {
          const result = this.$_.cloneDeep(this.items)

          const indexOrg = result.findIndex(i => i.organizationId === this.activeItemId)
          const questInd = result[indexOrg].questions[this.answerComment.index]

          if (questInd) {
            questInd.answer = res.answer
            questInd.answerTime = res.answerTime
            questInd.questionContact = res.questionContact
            questInd.answerContact = res.answerContact

            this.$emit('update:items', result)
            this.answerComment = null
          }
        }
      }).catch(() => {
        this.$notice.info({
          title: this.$t('Common.ErrorTitle'),
          message: this.$t('Errors.STHWrong'),
        })
      })
        .finally(() => {
          this.loading = false
        })
    }, 200),
  },
  computed: {
    ...mapGetters({
      stored_current_organization: 'getCurrentOrganization',
      user: 'GET_USER',
    }),
    activeItemId() {
      return this.itemId ? this.itemId : this.items[0].organizationId
    },
    activeChats() {
      const result = this.items.find(i => i.organizationId === this.activeItemId) || this.items[0] || []
      if (!result?.questions?.length) {
        return result
      }
      return result.questions.sort((a, b) => Date.parse(a.questionTime) - Date.parse(b.questionTime))
    },
  },
  watch: {
    show: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          const withoutAnswer = this.activeChats?.filter(i => !i.answer) || []

          if (withoutAnswer?.length === 1) {
            this.answerComment = {
              index: this.activeChats.findIndex(i => i.questionId === withoutAnswer[0].questionId),
              value: {
                organizationTitle: withoutAnswer[0].organizationTitle,
                question: withoutAnswer[0].question.message,
                questionId: withoutAnswer[0].questionId,
              }
            }
          } else {
            this.answerComment = null
          }
          setTimeout(() => {
            const itemActive = document.getElementsByClassName('comments-item active')
            if (itemActive?.length) {
              itemActive[0].scrollIntoView({block: 'center', behavior: 'smooth'})
            }
          }, 250)
        }
      }
    }
  },
  created() {
    const itemActive = document.getElementsByClassName('comments-item active')
    if (itemActive?.length) {
      itemActive[0].scrollIntoView({block: 'center', behavior: 'smooth'})
    }
  },
  props: {
    /**
     * Вопросы от поставщиков
     */
    items: {
      type: Array
    },
    /**
     * Текущая организация
     */
    itemId: {
      type: [String, Number]
    },
    show: {
      type: Boolean
    },
    /**
     * Данные тендеров
     */
    tender: {
      type: Object
    },
  },
  components: {
    UserIcon,
    CommentCard,
    ChatTemplate,
    CommentsChat
  }
}
</script>
<style scoped lang="scss">
@import 'toolkit/style/variables.scss';

.comments {
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	height: 100%;
	overflow: auto;
}
.comments-col-1 {
	width: 25%;
	min-width: 100px;
	overflow: auto;
	height: 100%;
}
.comments-col-2 {
	height: 100%;
	overflow: auto;
	overflow-x: hidden;
	display: flex;
	position: relative;
	flex-wrap: wrap;
	border-radius: 8px;
	align-content: flex-start;
	align-content: space-between;
	background: var(--v-main__light_green-base);
	width: calc(75% - 10px);
}
.comments-head-title {
	margin: auto 0 auto 10px;
	font-weight: 500;
	font-size: 14px;
	line-height: 18px;
}
.comments-item {
	background: var(--v-secondary__green_chosen-base);
	transition: all 0.25s ease;
	&:hover {
		background: var(--v-main__light_green-base);
	}
	&:focus {
		background: var(--v-main__light_green-base);
	}
	&.active {
		background: var(--v-main__light_green-base);
	}
}
.comments-question {
  padding: 5px 10px;
  position: absolute;
  top: -42px;
  left: 8px;
  right: 8px;
  background: var(--green_chosen_light);
  display: flex;
  justify-content: space-between;
}
.comments-question-title {
  font-weight: 500;
  font-size: 11px;
  line-height: 12px;
}
.comments-question-question {
  font-size: 11px;
  line-height: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
